class PageAccordionComponent extends HTMLElement {
	connectedCallback() {
		this.accordions = this.querySelectorAll("accordion-custom");
		this.imageContainer = this.querySelector(".page-accordion-image");

		const defaultImg = this.imageContainer?.querySelector("img");
		this.defaultImg = defaultImg ? /** @type {HTMLImageElement} */ (defaultImg.cloneNode(true)) : null;

		this.accordions.forEach((accordion) => {
			const details = accordion.querySelector("details");
			if (!details) return;

			details.addEventListener("toggle", () => {
				if (details.open) {
					this.#activate(accordion);
				}
			});
		});

		// Initialize image for any accordion that is open by default
		const firstOpen = [...this.accordions].find((a) => a.querySelector("details")?.open);
		if (firstOpen) this.#updateImage(firstOpen);
	}

	/** @param {Element} activeAccordion */
	#activate(activeAccordion) {
		this.accordions?.forEach((accordion) => {
			if (accordion !== activeAccordion) {
				const details = accordion.querySelector("details");
				if (details?.open) details.open = false;
			}
		});
		this.#updateImage(activeAccordion);
	}

	/** @param {Element} accordion */
	#updateImage(accordion) {
		if (!this.imageContainer) return;

		const imageUrl = /** @type {HTMLElement} */ (accordion).dataset.image;
		const img = this.imageContainer.querySelector("img");

		if (imageUrl) {
			if (img) {
				img.src = imageUrl;
				img.srcset = "";
				img.sizes = "";
			} else {
				const newImg = document.createElement("img");
				newImg.src = imageUrl;
				newImg.className = "image-block__image border-style";
				this.imageContainer.appendChild(newImg);
			}
		} else if (this.defaultImg) {
			const defaultImg = /** @type {HTMLImageElement} */ (this.defaultImg);
			if (img) {
				img.src = defaultImg.src;
				img.srcset = defaultImg.srcset;
				img.sizes = defaultImg.sizes;
			} else {
				this.imageContainer.appendChild(defaultImg.cloneNode(true));
			}
		}
	}
}

if (!customElements.get("page-accordion-component")) {
	customElements.define("page-accordion-component", PageAccordionComponent);
}
